import {AbstractControl} from '@angular/forms';

export class CustomValidators {
  static locationMatcher(c: AbstractControl): { [key: string]: boolean } | null {
    let departureControl = c.get('departure');
    let destinationControl = c.get('destination');

    if (departureControl.pristine && destinationControl.pristine) {
      return null;
    }

    let departureControlValue = +departureControl.value;
    let destinationControlValue = +destinationControl.value;

    if (departureControlValue !== destinationControlValue) {
      return null;
    }
    return {'match': true};
  }

  static dateRange(c: AbstractControl): { [key: string]: boolean } | null {
    let fromDateControl = c.get('from_date');
    let toDateControl = c.get('to_date');

    if (fromDateControl.pristine || toDateControl.pristine) {
      return null;
    }

    let fromDateControlValue = fromDateControl.value;
    let toDateControlValue = toDateControl.value;

    let fromDateControlValueDate: Date = new Date(fromDateControlValue.year, fromDateControlValue.month - 1, fromDateControlValue.day);
    let toDateControlValueDate: Date = new Date(toDateControlValue.year, toDateControlValue.month - 1, toDateControlValue.day);

    if (fromDateControlValueDate <= toDateControlValueDate) {
      return null;
    }

    return {'cross': true};
  }

  static oneSelected(c: AbstractControl): { [key: string]: boolean } | null {
    let selected = false;
    for (let i = 0; i <= 6; i++) {
      let formControlName = '' + i;
      if (c.get(formControlName).value) {
        selected = true;
        break;
      }
    }

    if (selected) {
      return null;
    }
    return {'none': true};
  }

  static minLengthArray(min: number) {
    return (c: AbstractControl): { [key: string]: any } => {
      if (c.value.length >= min) {
        return null;
      }

      return {'minLengthArray': true};
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/custom-validators.ts